import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePathBuilder } from '../../../core/routing/hooks/use-path-builder';
import { useCustomerQuery } from '../../../modules/customer/queries';
import { useUsersQuery } from '../../../modules/user/queries';
import { PageContainer } from '../../../modules/page-container/page-container';
import { FullPageLoader } from '../../../visual-components/full-page-loader/full-page-loader';
import { GridContainer, GridItem } from '../../../visual-components/grid/grid';
import { Link } from '../../../visual-components/link/link';
import { SectionHeader } from '../../../visual-components/section-header/section-header';
import { Spacer } from '../../../visual-components/spacer/spacer';
import { FullPageErrorView } from '../../../modules/full-page-error-view/full-page-error-view';
import { AddressList } from './components/address-list';
import { UserList } from './components/user-list';

export const Overview: React.FC = () => {
  const { t } = useTranslation();
  const { profilePath } = usePathBuilder();

  const {
    data: users,
    isLoading: isLoadingUsers,
    isSuccess: hasUsers,
    isError: hasErrorUsers,
    error: usersError,
  } = useUsersQuery();
  const {
    data: customer,
    isLoading: isLoadingCustomer,
    isSuccess: hasCustomer,
    isError: hasErrorCustomer,
    error: customerError,
  } = useCustomerQuery();

  if (isLoadingCustomer || isLoadingUsers) {
    return <FullPageLoader />;
  }

  if (hasErrorUsers || !hasUsers) {
    return <FullPageErrorView debugInfo="Error fetching user data" error={usersError} />;
  }

  if (hasErrorCustomer || !hasCustomer) {
    return <FullPageErrorView debugInfo="Error fetching customer data" error={customerError} />;
  }

  return (
    <PageContainer documentTitle={t('profile.settings.documentTitle')}>
      <GridContainer>
        <GridItem>
          <Link icon="arrow-left" to={profilePath()}>
            {t('profile.backToProfile')}
          </Link>
          <Spacer size="06" />
          <SectionHeader>{customer.data.name}</SectionHeader>
        </GridItem>
      </GridContainer>
      <UserList companyName={customer.data.name} data={users} />
      <Spacer size="08" />
      <AddressList data={customer} />
    </PageContainer>
  );
};
